export const subNavItems = [
  {
    value: 'summary',
    label: 'Fund Summary',
  },
  {
    value: 'more-about-fund',
    label: 'More about Fund',
  },
  {
    value: 'related-funds',
    label: 'Related funds',
  },
  {
    value: 'why-cleartax',
    label: 'Why Cleartax',
  },
  {
    value: 'faq',
    label: 'FAQs',
  },
];

export const returnKeyLabel = {
  return10yr: '10 Years',
  return5yr: '5 Years',
  return3yr: '3 Years',
  return1yr: '1 Year',
  return6mth: '6 Months',
};

export const faqs = {
  title: 'Frequently Asked Questions',
  faqs: [
    {
      question: 'What are equity funds?',
      answer:
        'Equity funds are schemes which concentrate their investments in shares of companies of different market capitalization',
    },
    {
      question: 'What is recommended investment duration?',
      answer:
        'It is the suggested period for which one should invest in a mutual fund. It does not mean that the money will be locked-in for that period. While the investor can withdraw the money anytime before, it is advisable to stay invested for the suggested period to reap the best benefits (returns).',
    },
    {
      question:
        'What are large cap, mid cap, small cap and multi cap equity funds?',
      answer:
        'SEBI ranks all listed companies based on the overall market capitalization (total value of outstanding shares).\nEquity funds are schemes which concentrate their investments in shares of companies of different market capitalization.\nLarge-cap funds invest in top 100 companies\nMid-cap funds invest in companies ranking from 101 to 250\nSmall-cap funds invest in companies ranking from 251st onwards\nMulti-cap funds invest in small cap, mid cap and large cap companies',
    },
    {
      question: 'What are liquid funds?',
      answer:
        'Liquid funds is a type of mutual funds which have a very short maturity period, not more than 91 days. The shorter maturity period, makes it almost a risk-free investment. Investing in mutual funds will give you higher returns as compared to a savings account which generally offer interests below 4%. At the same time, you can get your money out of liquid funds any time without any penalty or cost.',
    },
    {
      question: 'What are ELSS funds?',
      answer:
        'ELSS funds are tax saving mutual funds, in which majority of the funds are invested in equity schemes. ELSS has a lock-in period of 3 years. ELSS has benefits over other conventional tax saving instruments like FDs, NPS, etc. It has the lowest lock in period and the returns are higher than the other tax-saving schemes.',
    },
    {
      question: 'What are Balanced/ Hybrid funds?',
      answer:
        'Hybrid funds are mutual funds in which the fund manager allocates your money in both equity and debt in a certain ratio. The ratio is decided when the fund is announced and it remains constant throughout.',
    },
    {
      question: 'What are annualized returns?',
      answer:
        'The return for a period more than 1 year is annualized. For instance, a 3-Year Return (annualized) of 18% means the fund gave 18% return each year, on an average, for the last 3 years. An initial investment of Rs 1000 would have grow into: Rs 1000*1.18*1.18*1.18 = Rs 1643 in 3 years.',
    },
    {
      question: 'What is a lock-in period?',
      answer:
        'It is the period for which your money will remain locked in the mutual fund. Most mutuals do not have any lock-in period. ELSS, Tax-Savers, come with a lock-in of 3 years which is the lowest compared to other 80C investment options.',
    },
    {
      question: 'Should I choose Monthly SIP or One time investment?',
      answer:
        'An SIP allows you to invest a fixed sum regularly in mutual fund(s) of your choice. A one-time investment is when you invest on-time in bulk in mutual fund(s). SIP comes with few advantages:\nIt allows you to invest small amount every month without the stress of paying in bulk.\nInvesting all through the year averages the cost of investing - you don?t end up paying too much per unit of mutual fund.\nGives you financial discipline',
    },
    {
      question: 'Is KYC necessary for ClearTax?',
      answer:
        'KYC is necessary for all fund houses. If you are investing through ClearTax, you need to do your KYC just once. The same KYC will be used for all further investments.',
    },
    {
      question: 'How to do KYC on ClearTax?',
      answer:
        'KYC verification through ClearTax is a very simple process. You can verify by:\nUsing OTP sent to your Aadhaar-registered mobile number OR\nBy uploading photos/scans of the required documents',
    },
    {
      question:
        'Will the NAV be alloted on the same day as the date of payment?',
      answer:
        'Once the payment is successful and the KYC is complete, the NAV allocation is expected to be done by the next working day of the date of payment. In case of bank and trading market holidays, delay in allocation is expected from the Fund Houses',
    },
    {
      question:
        'How much time will it take to get the folio number after the payment?',
      answer:
        'It takes 2-3 working days to get the folio number once we receive the payment and transaction is processed to the respective Fund House.',
    },
    {
      question: 'What are short terms funds?',
      answer:
        'Short term funds are mainly those funds which invest in instruments with short maturities, ranging from 1-3 years. These are ideal for conservative investors as they are not majorly affected by interest rate movement.',
    },
    {
      question: 'What are debt-funds?',
      answer:
        'Debt funds is an investment vehicle that mainly invest in fixed income securities like corporate bonds, treasury bills, government securities and other money market instruments.',
    },
    {
      question: 'What are Bluechip funds?',
      answer:
        'Bluechip funds are those funds that invest in stocks of well established companies which have proved to perform financially well over a long period of time.',
    },
  ],
};

export const checkoutEnabled = true;

export const MF_PAGES_API_URL =
  'https://mfpagesbackend-prod-https.internal.cleartax.co';

export const breadCrumbDefault = {
  link: '/save',
  text: 'Home',
};

export const ELSS_CATEGORY = 'ELSS (Tax Savings)';

export const FUND_PURCHASE_MODES = {
  regular: 'REGULAR',
  direct: 'DIRECT',
};



// WEBPACK FOOTER //
// ./constants/fundPages.ts